{
  "version": 1,
  "entries": [
    {
      "id": "2026-11-teams",
      "date": "2026-11-02",
      "tag": "Teams",
      "title": "Invite your team to work in your account",
      "body": "Give staff, camera operators and clients their own sign-in to your account or to one event, as an admin, editor or moderator, at no extra cost. Each person streams, edits and moderates without sharing your password. Open Profile and choose Team to invite them.",
      "link": {
        "label": "Team members guide",
        "url": "https://www.eventlive.pro/help/how-to-add-team-members-to-your-business-account"
      },
      "try": {
        "label": "Invite your team",
        "action": "team"
      },
      "platforms": [
        "web"
      ]
    },
    {
      "id": "2026-10-event-analytics",
      "date": "2026-10-30",
      "tag": "Analytics",
      "title": "Analytics that count every viewer and never expire",
      "body": "Event Analytics now counts viewers on every device, apps, smart TVs and embeds included, with live viewers by the minute and watch time by country, region and device. Reports are kept for good and show each event's viewer-hours against the 5,000 included. Open an event and choose Event Analytics; events before Oct 30 move over on Nov 6.",
      "link": {
        "label": "What Event Analytics shows",
        "url": "https://www.eventlive.pro/help/how-to-see-who-watched-your-event#event-analytics-business-accounts"
      },
      "platforms": [
        "web"
      ]
    },
    {
      "id": "2026-10-embed-on-your-site",
      "date": "2026-10-13",
      "tag": "Better Embed",
      "title": "Sell tickets and sign guests up on your own website",
      "body": "Your embedded event now shows the ticket or sign-up card right on your page, sizes itself with no scrollbars and remembers viewers who already paid. Guest emails can link back to your site, so families and fans keep coming to you. Open an event, choose Embed and copy the new code to try it.",
      "link": {
        "label": "How embedding works",
        "url": "https://www.eventlive.pro/help/how-to-embed-eventlive-streams-on-your-website"
      }
    },
    {
      "id": "2026-10-ticket-options",
      "date": "2026-10-13",
      "tag": "Tickets",
      "title": "More ways to sell tickets",
      "body": "Sell a pass for the whole event, single-day tickets, the replay or a video download, and let buyers cover the fees if you like. Multi-room events can sell one ticket for every room or one per room, and Apple Pay and Google Pay now work on embedded event pages too. Open an event and choose Sell Tickets to set it up.",
      "link": {
        "label": "Ticket options guide",
        "url": "https://www.eventlive.pro/help/how-to-sell-tickets-for-a-livestream-event#fixed-price-ticket-options"
      }
    },
    {
      "id": "2026-10-branded-live-emails",
      "date": "2026-10-13",
      "tag": "Branding",
      "title": "\"We're live\" emails now carry each event's branding",
      "body": "When you go live, guests get the email with the event's own logo and company name instead of your profile defaults. That's ideal when you stream for different clients, venues or locations. Set it in any event under Event Branding.",
      "link": {
        "label": "Branding guide",
        "url": "https://www.eventlive.pro/help/eventlive-white-label-service-availability#add-branding-to-an-individual-event"
      }
    },
    {
      "id": "2026-10-replay-reliability",
      "date": "2026-10-09",
      "tag": "Reliability",
      "title": "Better iPhone and Android apps",
      "body": "We've made hundreds of improvements to our iPhone and Android apps for stability, audio, stream quality and ease of use. Replays now keep every minute, even when your connection drops and reconnects. Update the EventLive app on your phone before your next event.",
      "link": {
        "label": "Going live from your phone",
        "url": "https://www.eventlive.pro/help/how-to-go-live-on-the-day-of-the-event-using-the-app"
      },
      "try": {
        "label": "Start free test",
        "action": "startTest"
      }
    },
    {
      "id": "2026-10-mac-app",
      "date": "2026-10-08",
      "tag": "New Mac App",
      "title": "Go live from your Mac with the new EventLive app",
      "body": "Switch between webcams and your iPhone camera, change microphones mid-stream and share your screen, all from one window. The app adjusts quality automatically on weak Wi-Fi and keeps a backup copy of your stream. It's a free download for anyone with an EventLive account.",
      "link": {
        "label": "Mac setup guide",
        "url": "https://www.eventlive.pro/help/how-to-go-live-from-your-mac"
      },
      "try": {
        "label": "Download for Mac",
        "url": "https://www.eventlive.pro/mac"
      }
    },
    {
      "id": "2026-10-big-uploads",
      "date": "2026-10-06",
      "tag": "Video",
      "title": "Upload big edited videos, get a sharper replay",
      "body": "Upload MOV or MP4 files up to 200 GB before, after or in between your live segments. If your connection drops, the upload picks up where it left off, and 1080p or 4K files now give viewers a 1080p replay. Open an event, choose Manage Video, then Upload video.",
      "link": {
        "label": "Upload specs",
        "url": "https://www.eventlive.pro/help/video-quality-and-technical-specs#uploaded-videos-manage-video"
      }
    },
    {
      "id": "2026-10-rooms",
      "date": "2026-10-01",
      "tag": "Multi-camera",
      "title": "Rooms: stream several cameras or rooms from one event",
      "body": "Stream from up to 9 cameras or rooms under one event link, each with its own stream key, player and chat. Viewers switch between them with tabs, and one sign-in or ticket can cover them all. Open an event and choose Add a room, stage or track (each room uses one credit per day).",
      "link": {
        "label": "Rooms guide",
        "url": "https://www.eventlive.pro/help/multi-room-events"
      }
    },
    {
      "id": "2026-09-fundraising",
      "date": "2026-09-30",
      "tag": "Fundraising",
      "title": "Raise donations during your live stream",
      "body": "Choose a nonprofit and a Donate button appears beside your video, with a live tracker of the amount raised on your stream and every gift shown in the guestbook. It's powered by Pledge: donations are paid out to the nonprofit monthly, and donors get a tax receipt. Open an event and choose Fundraising to turn it on.",
      "link": {
        "label": "Fundraising guide",
        "url": "https://www.eventlive.pro/help/fundraisers-and-donations-for-nonprofits"
      }
    },
    {
      "id": "2026-09-nonprofit-free-streaming",
      "date": "2026-09-30",
      "until": "2026-12-31",
      "roles": [
        "nonprofit"
      ],
      "tag": "Offer",
      "title": "Nonprofits stream free through December 31",
      "body": "US 501(c)(3) nonprofits listed on Pledge stream for free: turn on fundraising, and every event you create by December 31, 2026 is unlocked, even if it takes place in 2027. GivingTuesday is December 1, a great day to go live.",
      "link": {
        "label": "Offer details",
        "url": "https://www.eventlive.pro/help/fundraisers-and-donations-for-nonprofits#nonprofit-offer-free-streaming-through-december-31-2026"
      },
      "try": {
        "label": "Schedule a fundraiser",
        "action": "createFundraiser"
      }
    },
    {
      "id": "2026-09-support-chat",
      "date": "2026-09-29",
      "tag": "Support",
      "title": "Answers in seconds from our support chat",
      "body": "Open the support chat in the app any time: the AI is now up to date with your account and all of our updates, and our support team is close by. All our guides now live in one place at eventlive.pro/help.",
      "link": {
        "label": "Getting help",
        "url": "https://www.eventlive.pro/help/is-support-available-during-my-live-stream#how-to-get-support-during-your-live-stream"
      },
      "try": {
        "label": "Open support chat",
        "action": "openSupport"
      }
    }
  ]
}
